import { render, staticRenderFns } from "./dashboard_login_login.vue?vue&type=template&id=6407b2e4&"
import script from "./dashboard_login_login.vue?vue&type=script&lang=js&"
export * from "./dashboard_login_login.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_login_login.vue?vue&type=style&index=0&id=6407b2e4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports